import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitAbbreviation',
})
export class UnitAbbreviationPipe implements PipeTransform {
  private unitMap :{ [key :string] :string } = {
    centimeters: 'cm',
    inches: 'in',
    ounces: 'oz',
    pounds: 'lbs',
  };

  transform(value :string) :string {
    return this.unitMap[value] || value;
  }
}
